import { useGetExerciseTypesSearch } from '#api/exercise-types';
import styled from 'styled-components';

const StyledSearchList = styled.ol<{ isOpen?: boolean }>`
  max-height: 35vh;
  display: ${props => (props.isOpen ? 'block' : 'none')};
  width: 100%;
  padding: 0 20px;
  border-radius: 8px;
  background: var(--bg-700, #262231);
  overflow-y: auto;
  margin-top: 8px;
`;

interface SearchListProps {
  onClick: (value: string) => void;
  exerciseKeyword: string;
}

/**
 * @param {string} exerciseKeyword - 검색 키워드
 * @param {function} onClick - 검색 리스트 클릭 시 실행할 함수
 */
export const SearchList = ({
  exerciseKeyword,
  onClick: onChange
}: SearchListProps) => {
  // 운동 검색 리스트
  const { data: exerciseList } = useGetExerciseTypesSearch({
    name: exerciseKeyword
  });

  const isOpenSearchList =
    !!exerciseKeyword && exerciseList && exerciseList?.length > 0;

  if (!exerciseList) return <div></div>;

  return (
    <StyledSearchList isOpen={isOpenSearchList}>
      {exerciseList.map((item, index) => (
        <li
          className="w-full py-20 text-[#d7d2de] text-[17px] font-medium font-['Pretendard Variable'] leading-snug border-b-1 border-[#2e2a3a] border-solid last:border-0"
          key={`${item.name}${index}`}
          onClick={() => {
            onChange(item.name);
          }}
        >
          {item.name}
        </li>
      ))}
    </StyledSearchList>
  );
};
